export default "__VITE_ASSET__cb07596c__"